import React from 'react'
import cx from 'classnames'

import Text from 'components/_new/typography/Text/Text'

import s from './Note.scss'


const Note = ({ className, message, big }) => (
  <Text className={cx(big ? s.noteBig : s.note, className)} message={message} html />
)

export default Note
